import { render, staticRenderFns } from "./GiftCardConfig.vue?vue&type=template&id=cf9f92a6"
import script from "./GiftCardConfig.vue?vue&type=script&lang=js"
export * from "./GiftCardConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports